module.exports = __webpack_public_path__ + "img/project-4.51647a15.jpg";